export const LOGGED_OUT = 'Logged Out';
export const LOGGING_IN = 'Logging In';
export const LOGGED_IN = 'Logged In';
export const LOGGED_IN_UNVERIFIED = 'Logged In - Unverified';
export const LOGGING_OUT = 'Logging Out';
